const page = require("../../../../../components/page/page");
const providerProfitDt = require("./providerProfit-dt");

import providerProfitPage from "./providerProfit-page.html";

/****************ELEMENTS*****************/
var HTMLwasSelected = false;

//insert the page  on the body
function HTMLselect(detail) {
  //console.log('providerProfit init>')

  HTMLwasSelected = true;

  //load the page to the index
  const body = document.body;
  body.insertAdjacentHTML("beforeend", providerProfitPage);

  providerProfitDt.start({
    dest: "providerProfit",
    act: "fecthData",
  });
} /*init*/

/****************ELEMENTS*****************/

export function start(detail) {
  //console.log('providerProfit page >', detail)

  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
}

const obj = {
  show: {
    start: (detail) => {
      page.start(detail);
    },
  },
}; /**/
